export default __webpack_public_path__ + "static/media/card-radio-button.920a520a.svg";